import React, { Component } from 'react';
import { SidebarPortal } from '@plone/volto/components';
import Sidebar from '@redturtle/iovisit-theme/components/Blocks/MultimediaFolderGallery/Sidebar';
import Body from '@redturtle/iovisit-theme/components/Blocks/MultimediaFolderGallery/Body';

class Edit extends Component {
  render() {
    if (__SERVER__) {
      return <div />;
    }

    return (
      <div className="block multimedia-folder-gallery">
        <Body {...this.props} isEditMode={true} />
        <SidebarPortal selected={this.props.selected}>
          <Sidebar {...this.props} />
        </SidebarPortal>
      </div>
    );
  }
}

export default Edit;
